import './GatewayPage.css';

export default function GatewayPage() {
  const cards = [
    {
      title: 'Mobile Mechanic',
      description:
        'Oil changes, brakes, battery replacement, diagnostics and more — at your home or workplace.',
      button: 'Book Mobile Service',
      href: '/mobile',
      image: '/images/mobile-service.jpg',
    },
    {
      title: 'Mechanical Shop',
      description:
        'Professional in-shop repair and maintenance including suspension, engine diagnostics and full mechanical services.',
      button: 'Enter Mechanical Shop',
      href: '/mechanical-shop',
      image: '/images/mechanical-shop.jpg',
    },
    {
      title: 'Body & Paint Shop',
      description:
        'Collision repair, dent repair, bumper repair, painting and insurance claim assistance.',
      button: 'Enter Body Shop',
      href: '/body-shop',
      image: '/images/body-paint-shop.jpg',
    },
  ];

  return (
    <div className="gateway-page">
      <div className="gateway-container">

        <div className="gateway-header">
          <div className="logo-bar">
            <img src="/Logo.png" alt="CarCure Logo" className="gateway-logo" />
          </div>

          <h1>
            Professional Auto Repair
            <span>Mobile & In-Shop</span>
          </h1>

          <p className="gateway-subtitle">
            Mobile Service, Mechanical Repair, and Body Work
            <br />
            All from one trusted auto service center in Richmond Hill
          </p>
        </div>

        <div className="gateway-cards">
          {cards.map((card) => (
            <a key={card.title} href={card.href} className="gateway-card">
              <div className="gateway-image">
                <img src={card.image} alt={card.title} />
              </div>

              <div className="gateway-card-content">
                <h2>{card.title}</h2>
                <p>{card.description}</p>

                <div className="gateway-button">
                  {card.button}
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="why-section">
          <h3>Why Customers Trust CarCure</h3>

          <div className="why-grid">

            <div className="why-box">
              <div className="why-icon">🔍</div>
              <h4>Transparent Service</h4>
              <span>Clear estimates and honest recommendations with no hidden surprises.</span>
            </div>

            <div className="why-box">
              <div className="why-icon">💲</div>
              <h4>Competitive Pricing</h4>
              <span>Fair pricing with professional quality and no unnecessary upselling.</span>
            </div>

            <div className="why-box">
              <div className="why-icon">✅</div>
              <h4>Satisfaction Guaranteed</h4>
              <span>We stand behind our repairs and customer experience.</span>
            </div>

            <div className="why-box">
              <div className="why-icon">🛠️</div>
              <h4>Quality Repairs</h4>
              <span>Reliable workmanship using quality parts and materials.</span>
            </div>

            <div className="why-box">
              <div className="why-icon">⚡</div>
              <h4>Fast & Reliable</h4>
              <span>Quick turnaround times and dependable service you can trust.</span>
            </div>

          </div>
        </div>

        <div className="contact-strip">
          <h3>Serving Richmond Hill & Surrounding Areas</h3>

          <div className="contact-items">
            <div className="contact-item">
              <span>📍</span>
              <p>28 Industrial Rd Unit 3, Richmond Hill, ON</p>
            </div>

            <div className="contact-item">
              <span>📞</span>
              <p>705-313-3414</p>
              <p>/ 705-991-2321</p>
            </div>

            <div className="contact-item">
              <span>✉</span>
              <p>info@carcure.ca</p>
            </div>
          </div>

          <div className="contact-buttons">
            <a href="tel:7053133414" className="contact-btn primary">
              Call Now
            </a>

            <a
              href="https://www.google.com/maps/search/?api=1&query=CarCure+Richmond+Hill"
              target="_blank"
              rel="noreferrer"
              className="contact-btn"
            >
              Get Directions
            </a>
          </div>
        </div>

      </div>
    </div>
  );
}